import { interpolateRgb, scaleLinear } from 'd3';
import { interpolateViridis } from 'd3-scale-chromatic';

// This function interpolates viridis between 0 - 0.8. And then between 0.8 - 1 it goes to red
export const interpolateColour = (value: number) => {
    const viridisThreshold = 0.8;
    if (value <= viridisThreshold) {
        const linearFunction = scaleLinear().domain([0, viridisThreshold]).range([0.05, 1]);
        return interpolateViridis(linearFunction(value));
    } else {
        const linearFunction = scaleLinear().domain([viridisThreshold, 1]).range([0, 1]);
        return interpolateRgb(interpolateViridis(1), '#fe450b')(linearFunction(value));
    }
};
